import Repository from '../axios'

const resource = "/landlord/country-code"

export default {
  get(){
    return Repository.get(`${resource}`)
  }
}
